import { render } from "./TicketCreationRequest.vue?vue&type=template&id=11842902"
import script from "./TicketCreationRequest.vue?vue&type=script&lang=ts"
export * from "./TicketCreationRequest.vue?vue&type=script&lang=ts"

import "./TicketCreationRequest.vue?vue&type=style&index=0&id=11842902&lang=scss"
script.render = render

export default script